<div class="modal-body" id="modal-body">
  <ng-container *ngIf="contentType === 'detail'; else listBlock">
    <app-entity-types-detail [pk]="pk" [mode]="mode" [defaults]="defaults"
                                   (detailSaved)="modal.close($event)"
                                   (detailCancelled)="modal.dismiss()">
    </app-entity-types-detail>
  </ng-container>
  <ng-template #listBlock>
    <app-entity-types-list (rowClick)="modal.close($event)" [disableUrlUpdate]="true"
                           [disabledButtons]="localDisabledButtons" [disabledColumns]="disabledColumns"
                           [filters]="filters" [disableRouterLink]="true">
    </app-entity-types-list>
  </ng-template>
</div>